export interface Project {
  id: number;
  name: string;
  dateStartDistribution: string;
  dateEndDistribution: string;
  dateReference: string;

  indexNeighborhoodOriginalShare: number;
  indexNeighborhoodDemographicShare: number;
  indexNeighborhoodOutletShare: number;
  indexNeighborhoodDistanceShare: number;

  indexSectorOriginalShare: number;
  indexSectorDemographicShare: number;
  cutoffOriginalData: number;

  createdAt: string;
}

export const tabs = { list: 'list', form: 'form', process: 'process', audit: 'audit' };
